import pluralize from 'pluralize'
import type { JSX } from 'react'
import { Link } from '#src/components/core/Link.tsx'

interface DuplicateFilesMessageProps {
  duplicates: { fileName: string; documentId: string }[]
  // Where a duplicate's existing document opens; its id is appended as a query.
  documentsUrl: string
}

export function DuplicateFilesMessage({
  duplicates,
  documentsUrl,
}: DuplicateFilesMessageProps): JSX.Element {
  return (
    <div className="flex flex-col gap-1" data-testid="duplicate-files-toast">
      <p>
        {duplicates.length} {pluralize('file', duplicates.length)} already on
        this chart, so {duplicates.length === 1 ? 'it was' : 'they were'} not
        uploaded:
      </p>
      <ul className="list-disc pl-4">
        {duplicates.map(({ fileName, documentId }) => (
          <li key={`${documentId}:${fileName}`}>
            <Link
              to={`${documentsUrl}?documentReferenceId=${documentId}`}
              className="underline"
            >
              {fileName}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
